
import React, {Component} from 'react';
import {FormControl,Button,ButtonToolbar,FormGroup,Form} from 'react-bootstrap'
import Select from 'react-select'
import FontAwesome from 'react-fontawesome'
import ReactPaginate from 'react-paginate';
import { Box } from 'reactjs-admin-lte'
import WorkdocStore from '../../stores/WorkdocStore'
import SWTCustomerEditModal from './SWTCustomerEditModal'
import ReportCustomerHistoryModal from '../report/ReportCustomerHistoryModal'
import withSizes from 'react-sizes';
import ReportMobileTable from '../report/ReportMobileTable'
import IframeModal from 'component/element/IframeModal'
import { Checkbox } from 'react-icheck'

const NotificationSystem = require('react-notification-system');
class SWTCustomerPage extends Component {

  constructor(...args){
    super(...args)
    this.state = {isPrint:false,check_itemlist:[],isCheckAll:false,account_edit_view:'short_view',loading:false,showEdit:false,showHistory:false,catSelect:null,curPage:0,pageCount:0,query:'',catOptions:[],tableData:[]}

    this.loadPage(true) 
  }

  loadPage(init){
    if(typeof init !=='undefined')
      this.state  = Object.assign(this.state,{loading:true})
    else
      this.setState({loading:true})

    let that = this
    WorkdocStore.loadCustomerCategory(function(result){
      let options = result.data.map((item,index)=>{
        return {label:item.name,value:item.id}
      })
      that.setState({loading:false,catOptions:options})

      that.loadCustomerList('-1')
    })
  }

  loadCustomerList(categoryId,query,pageNo){
    let that = this
    let {check_itemlist} = this.state
    WorkdocStore.loadCustomerList(categoryId,query,pageNo,function(result){
      check_itemlist = result.data.map((item,index)=>{
        return {id:item.customer_id,isCheck:false}
      })
      that.setState({check_itemlist:check_itemlist,tableData:result.data,pageCount:result.totalPage,loading:false,account_edit_view:result.account_edit_view})
    })
  }

  checkAll() {
    let {check_itemlist} = this.state
    let find = check_itemlist.findIndex(x=>x.isCheck===false)
    let check = false
    if (find===-1)
      check = true
    return check
  }

  checkHas() {
    let {check_itemlist} = this.state
    let find = check_itemlist.findIndex(x=>x.isCheck===true)
    let check = false
    if (find!==-1)
      check = true
    return check
  }

  onCheckboxChange(index) {
    let {check_itemlist} = this.state
    if (check_itemlist[index].isCheck)
      check_itemlist[index].isCheck = false
    else
      check_itemlist[index].isCheck = true

    this.setState({check_itemlist:check_itemlist,isCheckAll:this.checkAll(),isPrint:this.checkHas()})
  }

  onCheckboxAllChange() {
    let {isCheckAll,check_itemlist} = this.state
    let new_list = []
    if (isCheckAll) {
      new_list = check_itemlist.map((item,index)=>{
        item.isCheck = false
        return item
      })
      this.setState({isCheckAll:false})
    } else {
      new_list = check_itemlist.map((item,index)=>{
        item.isCheck = true
        return item
      })
      this.setState({isCheckAll:true})
    }
    this.setState({check_itemlist:new_list,isPrint:this.checkHas()})
  }

  onHide(){

  }

  onSelectChange(value){
    // let {catSelect,curPage} = this.state
    if(value!==null)
      this.loadCustomerList(value.value);
    else
      this.loadCustomerList(-1);
    this.setState({catSelect:value,loading:true})
  }

  onTextChange(e){
    let {catSelect} = this.state
    let query = e.target.value

    if(typeof query!=='undefined' && query.length>2){
      if(typeof catSelect!=='undefined' &&catSelect!==null){
        this.loadCustomerList(catSelect.value,query);
      }else{
        this.loadCustomerList(-1,query);
      }
      this.setState({loading:true})
    }
    this.setState({query:query})
    
  }

  onNewClick(){
    this.refs.wageitemedit.loadItemcode(null,this.state.catOptions)
    this.setState({showEdit:true})
  }

  onEditClick(item){
    this.refs.wageitemedit.loadItemcode(item,this.state.catOptions)
    
    this.setState({showEdit:true})
  }

  onHistoryClick(item){
    this.refs.customerHist.loadHistory(item)
    this.setState({showHistory:true})
  }

  onRowClick(item){
    
    //this.props.onSelect(item)
    if(typeof this.props.onSelectItem!=='undefined')
      this.props.onSelectItem(item)
    else{
      this.onEditClick(item)
    }
  }

  onClearClick(){
    this.setState({query:'',curPage:0,catSelect:null})
    this.loadCustomerList('-1')
  }

  onSaveClick(postData,completeFunc){
    WorkdocStore.saveCustomer(postData,completeFunc,(error)=>{

    })
  }

  onDelClick(item,completeFunc){
   
    
    
    //console.log('postData',postData)
    WorkdocStore.delCustomer(item.customer_id,completeFunc,(error)=>{

    })
  }

  onAfterSubmit(postData){
     //this.onClearClick()
  }

  onAfterDelete(){
    this.onClearClick()
  }

  onSearchAfterSubmit(postData) {
    this.refs.notificationSystem.addNotification({
      title:'แจ้งเตือน',
      message: 'เพิ่มข้อมูลลูกค้า "'+postData.name+'"" เรียบร้อย',
      level: 'info',
      position:'tc'
    })
    this.setState({query:postData.name})
    this.loadCustomerList(postData.cat_id,postData.name)
  }

  onPageChange(page){
    let {query,catSelect} = this.state

    let categoryId = (catSelect!==null)?catSelect.value:-1
    this.loadCustomerList(categoryId,query,page.selected)

    this.setState({curPage:page.selected})
  }

  onPrintClick() {
    let {check_itemlist} = this.state
    let doc_nos = []

    check_itemlist.forEach(function(item,index) {
      if (item.isCheck) {
        doc_nos.push(item.id)
      }
    })

    let doc_no = doc_nos.join()
    let file = 'PrintShippingLabel&idlist='+doc_no+'&doc=customer'
    let url = ''
    if (process.env.NODE_ENV === "development") {
      url = './?startPage='+file
    } else{
      url = './pdf/v2/?startPage='+file
    }
    this.refs.iframe.loadUrl(url)
  }

  renderSearch(){
    let {query,catSelect,catOptions,isPrint} = this.state
    let {showNew,isMobile} = this.props
    if(typeof showNew==='undefined'){
      showNew = true
    }
    
    return (
      <Form inline style={{marginBottom:'5px'}}>
        <FormGroup controlId="formInlineName" style={{width:(isMobile?'100%':'10%')}}>
          <Select 
            value={catSelect} 
            placeholder={'เลือกหมวดหมู่'} 
            options={catOptions} 
            onChange={this.onSelectChange.bind(this)}
          />
        </FormGroup>{' '}
        <FormGroup controlId="formInlineEmail" style={{width:(isMobile?'100%':'30%')}}>
          <FormControl value={query} onChange={this.onTextChange.bind(this)} style={{width:'100%'}} />
        </FormGroup>{' '}
        <Button onClick={this.onClearClick.bind(this)}><FontAwesome name="eraser"/>&nbsp;ลบการค้นหา</Button>{' '}
        <Button style={{display:showNew?'':'none'}} bsStyle={'primary'} onClick={this.onNewClick.bind(this)}><FontAwesome name="plus"/>&nbsp;เพิ่มรายการลูกค้า</Button>{' '}
        {isPrint?<Button bsStyle='danger' onClick={this.onPrintClick.bind(this)}><FontAwesome name='print' />&nbsp;พิมพ์ใบจ่าหน้าซอง</Button>
        :''}
      </Form>
    )
  }

  renderRowData(){
    let {tableData,check_itemlist} = this.state
    // let showEditColumn = (this.props.onSelectItem!==undefined)
    return tableData.map((item,index)=>(
      <tr key={index}>
        <td className='text-center'>
          <Checkbox
            onChange={this.onCheckboxChange.bind(this,index)}
            checked={check_itemlist[index].isCheck}
            checkboxClass="icheckbox_square-blue"
            increaseArea="20%"
            label={''}
          >
          </Checkbox>
        </td>
        <td  onClick={this.onRowClick.bind(this,item)}>{item.title}</td>
        <td  onClick={this.onRowClick.bind(this,item)}>{item.name}</td>
        <td  onClick={this.onRowClick.bind(this,item)}>{item.address}</td>
        <td  onClick={this.onRowClick.bind(this,item)}>{item.province}</td>
        <td  onClick={this.onRowClick.bind(this,item)}>{item.postalcode}</td>
        <td  onClick={this.onRowClick.bind(this,item)}>{item.tax_no}</td>
        <td  onClick={this.onRowClick.bind(this,item)} >{item.tel}</td>
        <td className='text-center' onClick={this.onRowClick.bind(this,item)} >{item.credit_day}</td>
        <td className='text-center'>
          <ButtonToolbar>
            <Button onClick={this.onHistoryClick.bind(this,item)}>ประวัติ</Button>
            <Button onClick={this.onEditClick.bind(this,item)} >แก้ไข</Button>
          </ButtonToolbar>
        </td>
      </tr>
    )) 
  }

  renderSearchResult(){
    let {isCheckAll} = this.state
    return (
      <div className='table-responsive'>
        <table className='table table-hover table-bordered-solid'>
          <thead>
            <tr>
              <th className='text-center'>
                <Checkbox
                  onChange={this.onCheckboxAllChange.bind(this)}
                  checked={isCheckAll}
                  checkboxClass="icheckbox_square-blue"
                  increaseArea="20%"
                  label={''}
                >
                </Checkbox>
              </th>
              <th>คำนำหน้า</th>
              <th>ชื่อลูกค้า</th>
              <th>ที่อยู่</th>
              <th>จังหวัด</th>
              <th>รหัสไปรษณีย์</th>
              <th>เลขที่ผู้เสียภาษี</th>
              <th>เบอร์โทร</th>
              <th>เครดิต</th>
              <th>ดูประวัติ/แก้ไข</th>
            </tr>
          </thead>
          <tbody>
            {this.renderRowData()}
          </tbody>
        </table>
      </div>  
    )
  }


  renderPaging(){
    let {pageCount} = this.state
    if(pageCount>0){
      return (
        <div className="commentBox">        
          <ReactPaginate  
                        previousLabel={"ก่อนหน้า"}
                        nextLabel={"ถัดไป"}
                        breakLabel={<a href="">...</a>}
                        breakClassName={"break-me"}
                        pageCount={this.state.pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={2}
                        onPageChange={this.onPageChange.bind(this)}
                        containerClassName={"pagination pull-right"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"} />
        </div>
      ); 
    } else{
      return (<div/>)
    }
  }

  onRowWorkClick(item,items) {
    this.onRowClick(items)
  }

  renderMobileTable(){
    let {tableData} = this.state
    let _data = []
    _data = tableData.map((item,index)=>{
      let _item = item
      _item = Object.assign({fullname:item.title+' '+item.name,_customer_type:(item.customer_type==='PERSON'?'บุคคล':'นิติบุคคล')}, _item)
      return _item
    })
    let fieldMap = {title:'fullname',amount:'tel',sub_title:'address',date:'',status:'',sub_status:''}
    return(
      <div>
        <ReportMobileTable
          itemlist={_data}
          fieldMap={fieldMap}
          keyIndex={'customer_id'}
          numberFormat={false}
          onRowClick={this.onRowWorkClick.bind(this)}
        />
      </div>
    )
  }

  render(){
    let {isMobile} = this.props
    let {loading,showEdit,showHistory} = this.state
    return (
      <div>
          <NotificationSystem ref="notificationSystem" />
          <Box loading={loading}>            
            <Box.Body>
              {this.renderSearch()}
              {isMobile?this.renderMobileTable():this.renderSearchResult()}
              {this.renderPaging()}
            </Box.Body>
          </Box>    
          <ReportCustomerHistoryModal ref='customerHist' show={showHistory} 
          onHide={()=>{this.setState({showHistory:false})}}
          />      
          <SWTCustomerEditModal  ref={'wageitemedit'} show={showEdit}   
          editTitle={'ลูกค้า'}
          accountEditView={this.state.account_edit_view}
          onSaveClick={this.onSaveClick.bind(this)}       
          onDelClick={this.onDelClick.bind(this)}             
          onAfterDelete={this.onAfterDelete.bind(this)}
          onAfterSubmit={this.onAfterSubmit.bind(this)}
          onSearchAfterSubmit={this.onSearchAfterSubmit.bind(this)}
          onHide={()=>{this.setState({showEdit:false})}}/>
          <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
      </div>
    )
  }
}

const mapSizesToProps = ({ width }) => ({
  isMobile: width < 480,
})

export default SWTCustomerPage = withSizes(mapSizesToProps)(SWTCustomerPage);


// WEBPACK FOOTER //
// ./src/view/workdoc/SWTCustomerPage.js